import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getPackingErrorRate = {
  name: "getPackingErrorRate" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
